import campaignAnalyticsReducer from "./campaignAnalyticsReducer";
import campaignLeadTrackReducer from "./campaignLeadTrackReducer";
import campaignsReducer from "./campaignsReducer";
import categoryReducer from "./categoryReducer";
import filterReducer from "./filterReducer";
import groupsReducer from "./groupsReducer";
import patientsReducer from "./patientsReducer";
import reportsReducer from "./reportsReducer";
import templatesReducer from "./templatesReducer";
import walletAndBillingReducer from "./walletAndBillingReducer";

const marketingBlastReducers = {
  MBReports: reportsReducer,
  MBPatients: patientsReducer,
  MBGroups: groupsReducer,
  MBCampaigns: campaignsReducer,
  MBCategory: categoryReducer,
  MBTemplates: templatesReducer,
  MBCampaignAnalytics: campaignAnalyticsReducer,
  MBCampaignLeadTrack: campaignLeadTrackReducer,
  MBFilter: filterReducer,
  MBWalletAndBilling: walletAndBillingReducer,
};

export default marketingBlastReducers;